<template>
    <input v-if="data.type=='text'"
           :type="data.type"
           :name="name"
           :id="inputFieldId"
           :required="data.required"
           :class="'form-control '+data.inputClass"
           :maxlength="data.maxLength"
           :minlength="data.minlength"
           :alphanumeric="data.alphanumeric"
           :placeholder="data.placeholder"
           :readonly="data.readOnly"
           :disabled="data.disabled"
           v-bind:value="value"
           v-on="listeners"
           :autocomplete="data.autocomplete"
    />
    <input v-else-if="data.type=='currency-right'"
           :type="data.type"
           :name="name"
           :id="inputFieldId"
           :required="data.required"
           :class="'form-control '+data.inputClass"
           style="text-align:right;"
           :maxlength="data.maxLength"
           :minlength="data.minlength"
           :alphanumeric="data.alphanumeric"
           :placeholder="data.placeholder"
           :readonly="data.readOnly"
           :disabled="data.disabled"
           v-bind:value="value"
           v-on="listeners"
           :autocomplete="data.autocomplete"
    />
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';

export default {
    name: "TextInput",
    mixins: [InputMixin]
}
</script>

